import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a09be76"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Stai aggiungendo un nuovo strumento", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nuova strumentazione", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Aggiungi le seguenti informazioni", -1))
const _hoisted_4 = { class: "title text-input input-content" }
const _hoisted_5 = { for: "primary-field-name" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_8 = { class: "title text-input input-content" }
const _hoisted_9 = { for: "secondary-field-name" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "font-light text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _hoisted_1
    ]),
    h3: _withCtx(() => [
      _hoisted_2
    ]),
    h2: _withCtx(() => [
      _hoisted_3
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onConfirm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Crea")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.modelValue.primaryFieldName), 1),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.primaryField.$error }]),
          id: "primary-field-name",
          type: "text",
          placeholder: `Inserisci ${_ctx.modelValue.primaryFieldName}`,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.primaryField) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.primaryField.$touch && _ctx.v$.primaryField.$touch(...args)))
        }, null, 42, _hoisted_6), [
          [_vModelText, _ctx.primaryField]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.primaryField.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, "È necessario inserire il campo " + _toDisplayString(_ctx.modelValue.primaryFieldName), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.modelValue.secondaryFieldName), 1),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.secondaryField.$error }]),
          id: "secondary-field-name",
          type: "text",
          placeholder: `Inserisci ${_ctx.modelValue.secondaryFieldName}`,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.secondaryField) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.secondaryField.$touch && _ctx.v$.secondaryField.$touch(...args)))
        }, null, 42, _hoisted_10), [
          [_vModelText, _ctx.secondaryField]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.secondaryField.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_11, "È necessario inserire il campo " + _toDisplayString(_ctx.tool.secondaryFieldName), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}